import snakeCase from 'lodash.snakecase';
import camelCase from 'lodash.camelcase';

import recursivelyTransformKeys from './recursively-transform-keys';

export const snakify = recursivelyTransformKeys(snakeCase);
export const camelize = recursivelyTransformKeys(camelCase);
